<template>
    <div>
        <h1 class="display-heading">Newsletter</h1>
        <p>
            Use this module to blast emails to recipients.
        </p>

        <div class="bs-stepper">
            <div class="bs-stepper-header" role="tablist">
                <div class="step" data-target="#choose-newsletter">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                        >
                            <span class="bs-stepper-circle">1</span>
                            <span class="bs-stepper-label">Choose Newsletter</span>
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#review-content">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                        >
                            <span class="bs-stepper-circle">2</span>
                            <span class="bs-stepper-label"
                                >Review Content</span
                            >
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#send-email">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                        >
                            <span class="bs-stepper-circle">3</span>
                            <span class="bs-stepper-label"
                                >Add Recipients and Send!</span
                            >
                        </button>
                    </div>
            </div>
            <div class="bs-stepper-content">
                <div
                        id="choose-newsletter"
                        class="content"
                        role="tabpanel"
                    >
                    <form data-vv-scope="formStep1" @submit.prevent="validateStep1">
                        <div class="form-group required">
                            <label>Newsletter Template</label>
                            <select data-vv-as="newsletter template" name="template" data-vv-validate-on="blur" v-model="formStep1.templateId" v-validate="'required'"
                                :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('formStep1.template')
                            }">
                                <option :value="null">Choose template...</option>
                                <option v-for="(template, index) in dropdownEmailTemplates" :key="index" :value="template.value">
                                    {{template.text}}
                                </option>
                            </select>
                            <div v-show="validationErrors.has('formStep1.template')" class="invalid-feedback">
                                {{ validationErrors.first('formStep1.template') }}
                            </div>
                        </div>
                        <button @click="goToStep2" type="button" class="btn btn-primary btn-primary-insv" >
                            Next
                        </button>
                    </form>
                </div>
                <div
                        id="review-content"
                        class="content"
                        role="tabpanel"

                    >

                    <form data-vv-scope="formStep2" @submit.prevent="validateStep2">
                        <div class="form-group">
                            <label>Newsletter Template Name</label>
                            <input type="text" class="form-control" readonly :value="selectedEmailTemplate?selectedEmailTemplate.newsletterName:'-'">
                        </div>
                        <div class="form-group">
                            <label>Email Will be Sent From</label>
                            <input type="text" class="form-control" readonly :value="(selectedEmailTemplate && selectedEmailTemplate.emailSenderDetails)?selectedEmailTemplate.emailSenderDetails.emailAddress:'-'">
                        </div>
                        <div class="form-group">
                            <label>Email Subject</label>
                            <input name="subject" type="text" v-model="formStep2.emailSubject" data-vv-as="email subject" data-vv-validate-on="blur" v-validate="'required'" :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('formStep2.subject')
                            }">
                            <div v-show="validationErrors.has('formStep2.subject')" class="invalid-feedback">
                                {{ validationErrors.first('formStep2.subject') }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Attachments</label>
                            <div>
                                <div v-if="selectedEmailTemplate && selectedEmailTemplate.attachments && selectedEmailTemplate.attachments.length > 0">
                                    <div v-for="(attachment, index) in selectedEmailTemplate.attachments" :key="index">
                                        {{ index+1 }}. <a href="javascript:void(0)" @click="getAttachment(attachment.attachmentPath)">{{attachment.fileName}}</a>
                                    </div>
                                </div>
                                <div v-else>
                                    <span>No attachments</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Email Content</label>
                            <div>
                            <textarea class="form-html-editor"></textarea>
                            </div>
                        </div>

                        <div class="mb-3">
                            <button type="button" class="btn btn-primary btn-primary-insv" @click="previewEmail">Preview Email</button>
                        </div>
                        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="goToStep3">
                            Next
                        </button>
                        <button type="button" class="btn btn-secondary" @click="startOver">
                            Start Over
                        </button>
                    </form>
                </div>
                <div
                        id="send-email"
                        class="content"
                        role="tabpanel"
                    >
                     <div class="mb-3">
                        <h5>Instructions</h5>
                        <ol>
                            <li>
                                Download the sample file template here.
                                <div><a href="/static/samples/newsletter-bulk-receiver-list.xlsx" target="_blank" class="mt-1 mb-2 btn btn-primary btn-primary-insv">Download Template File</a></div>
                            </li>
                            <li>
                                Open the downloaded file and fill up the file with the required fields. Example as below.
                                <div class="mt-1 mb-2">
                                    <img src="/static/samples/sample_bulk_newsletter_upload_list.png" class="img img-fluid">
                                </div>
                            </li>

                            <li>
                                Select and upload the file here.
                                <br>
                                <div>
                                    <form data-vv-scope="formStep3" @submit.prevent="validateStep3">
                                        <div>
                                            <div class="form-group">
                                                <div>
                                                    <input id="uploadFileInput" type="file" v-validate="'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" data-vv-as="email recipient list file" name="userList"
                                                        :class="{'is-invalid':  validationErrors.has('formStep3.userList')}">
                                                    <div v-show="validationErrors.has('formStep3.userList')" class="invalid-feedback">
                                                        {{ validationErrors.first('formStep3.userList') }}
                                                    </div>
                                                </div>
                                            </div>

                                            <p v-show="submit.isMessageShown" :class="{
                                                'text-danger': submit.isError,
                                                'mb-3': true
                                            }">
                                                {{submit.message}}
                                            </p>
                                        </div>
                                    </form>

                                </div>
                            </li>
                        </ol>
                    </div>

                    <div>
                        <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="submitForm">
                            Send Email
                        </button>
                        <button type="button" class="btn btn-secondary" @click="backToStep2">
                            Back to Previous Step
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <popup-modal ref="popupPreview" :hasCloseButton="true" :title="'Preview Email'" sizeClass="modal-lg">
            <template slot="content">
                <div v-html="this.formStep2.emailContent"></div>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="$refs.popupPreview.hide()">Dismiss</button>
                </div>
            </template>
        </popup-modal>

        <popup-modal ref="popupSent" :hasCloseButton="true" :title="'Newsletter Email Saved Successfully!'">
            <template slot="content">
                <div v-html="submit.message"></div>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="startOver">Okay</button>
                </div>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import Stepper from 'bs-stepper';
import tinymce from 'tinymce';
import 'tinymce/icons/default';

import 'tinymce/themes/silver';
/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'Newsletter',
    'components': {
        popupModal
    },
    data () {
        return {
            'stepper': null,
            'newsletterTemplates': [],
            'formStep1': {
                'templateId': null
            },
            'formStep2': {
                'emailSubject': null,
                'emailContent': null
            },
            'formStep3': {
                'saveToTemplate': true
            },
            'submit': {
                'isMessageShown': false,
                'isError': false,
                'message': null,
                'hasCount': false,
                'successEmailCount': 0
            },
            'tinymceInitialized': false
        };
    },
    'computed': {
        dropdownEmailTemplates () {
            return this.newsletterTemplates.map((template) => {
                return {
                    'text': template.newsletterName,
                    'value': template.newsletterEmailTemplateId
                };
            });
        },
        selectedEmailTemplate () {
            if (this.formStep1.templateId) {
                const template = this.newsletterTemplates.find((t) => t.newsletterEmailTemplateId === this.formStep1.templateId);

                return template;
            } return null;
        }
    },
    'watch': {
        selectedEmailTemplate (template) {
            if (template) {
                this.setEditorContent(template);
            }
        },
        tinymceInitialized (initialized) {
            if (initialized) {
                this.setEditorContent(this.selectedEmailTemplate);
            }
        }
    },
    mounted () {
        this.stepper = new Stepper(document.querySelector('.bs-stepper'));
        this.getAllNewsletterTemplates();
        this.tinymceInitialized = false;
        this.initializeTinyMce();
    },
    'methods': {
        initializeTinyMce () {
            tinymce.init({
                'selector': 'textarea.form-html-editor',
                'height': 800,
                'forced_root_block': '',
                'convert_urls': false,
                'plugins': 'advlist code emoticons link lists',
                'toolbar': 'bold italic | bullist numlist | link emoticons',
                'skin': false,
                'content_css': false,
                'content_style': ''
            }).then(() => {
                this.tinymceInitialized = true;
            });
        },
        getAllNewsletterTemplates () {
            this.axios.get('Newsletter/GetAllTemplates').then(({ data }) => {
                const emailTemplates = data.data;
                if (emailTemplates) {
                    this.newsletterTemplates = emailTemplates;
                }
            });
        },
        validateStep1 () {
            return this.$validator.validateAll('formStep1');
        },
        validateStep2 () {
            return this.$validator.validateAll('formStep2');
        },
        validateStep3 () {
            return this.$validator.validateAll('formStep3');
        },
        goToStep2 () {
            this.validateStep1().then((isValid) => {
                if (isValid) {
                    this.stepper.next();

                    this.initializeTinyMce();
                }
            });
        },
        goToStep3 () {
            this.validateStep2().then((isValid) => {
                if (isValid) {
                    this.formStep2.emailContent = tinymce.activeEditor.getContent();
                    this.stepper.next();
                }
            });
        },
        backToStep2 () {
            this.stepper.previous();
        },
        startOver () {
            location.reload();
        },
        previewEmail () {
            this.formStep2.emailContent = tinymce.activeEditor.getContent();

            this.$refs.popupPreview.show();
        },
        submitForm () {
            this.validateStep3().then((isValid) => {
                if (isValid) {
                    this.submit.isMessageShown = true;
                    this.submit.isError = false;
                    this.submit.message = 'Uploading and saving newsletter email...';
                    let bulkFile = document.querySelector('#uploadFileInput');
                    let formData = new FormData();
                    formData.append('RecipientListFile', bulkFile.files[0]);

                    formData.append('NewsletterTemplateId', this.formStep1.templateId);
                    formData.append('EmailSubject', this.formStep2.emailSubject);
                    formData.append('EmailContent', this.formStep2.emailContent);
                    formData.append('SaveToTemplate', this.formStep3.saveToTemplate);

                    this.axios.post('Newsletter/Send', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        } }).then(({ data }) => {
                        if (data.data) {
                            this.submit.hasCount = true;
                            this.submit.successEmailCount = data.data.count;
                        }

                        this.submit.message = 'Newsletter emails saved successfully.';
                        if (this.submit.hasCount) {
                            this.submit.message += ` ${this.submit.successEmailCount} email${this.submit.successEmailCount > 1 ? 's' : ''} sent.`;
                        }

                        this.$refs.popupSent.show();
                    }).catch(() => {
                        this.submit.isError = true;
                        this.submit.message = 'Error sending newsletter emails. Please try again.';
                    });
                }
            });
        },
        setEditorContent (template) {
            if (template) {
                this.formStep2.emailSubject = template.emailSubject;

                tinymce.activeEditor.setContent(template.emailContent == null ? '' : template.emailContent);
            }
        },
        getAttachment (attachmentPath) {
            this.axios.get('Newsletter/DownloadAttachment', {
                'params': {
                    'attachmentPath': attachmentPath
                }
            }).then(({ data }) => {
                if (data.data) {
                    // open in new tab
                    window.open(data.data, '_blank');
                }
            });
        }
    }
};
</script>

<style scoped>
.active .bs-stepper-circle {
    background-color: #009344;
}

.bs-stepper .step-trigger:focus {
  color: #009344;
  outline: none;
}
</style>
